const productForm = document.querySelector('#product-info');

if (productForm) {
    productForm.addEventListener('change', (event) => {
        handleChangeVariant();
    });
}

function handleChangeVariant() {
  getVariant();
}

async function getVariant() {
    const section_id = productForm.dataset.sectionId;
    let url = `${window.location.href}`;
    url += `&section_id=${section_id}`;
    const response = await fetch(url);
    const product = await response.text();
    updateProduct(product);
}

function updateProduct(data){
    const div = document.createElement("div");
    div.innerHTML = data;
    const productStock = div.querySelector("#stock");
    document.getElementById("stock").innerHTML = productStock.innerHTML;

    const productSellIcon = div.querySelector(".product-sell-icon");
    document.querySelector(".product-sell-icon").innerHTML = productSellIcon.innerHTML;

    

    const productShippingTime = div.querySelector(".shipping-time");
    const shippingTime = document.querySelector('.shipping-time');
    if (shippingTime) {
        shippingTime.setAttribute('data-deliverytime', productShippingTime.getAttribute('data-deliverytime'));
        shippingTime.setAttribute('data-deadline', productShippingTime.getAttribute('data-deadline'));
        shippingTime.setAttribute('data-everyday', productShippingTime.getAttribute('data-everyday'));
    }
    setTimeout(() => {
        AT_Main.deadLine_time();
        AT_Main.delivery_time();
    }, 200);
        
    
}